/** English of the interface (ADR 0069), keyed by the exact French phrase. See `index.ts`. */
export const STASH: Readonly<Record<string, string>> = {
  // ui/stash-panel.ts — the account's chest (ADR 0079)
  Coffre: 'Chest',
  'Partagé par tous les personnages de ton compte, dans chaque village.':
    'Shared by every character on your account, in every village.',
  'Le coffre s’ouvre…': 'Opening the chest…',
  'Déposé au coffre : {what}.': 'Put in the chest: {what}.',
  'Retiré du coffre : {what}.': 'Taken from the chest: {what}.',
  'Cet objet n’est plus là.': 'That item is no longer there.',
  'Cet objet est lié à ton personnage : le coffre ne prend pas les objets liés.':
    'This item is bound to your character: the chest takes no bound items.',
  'Les apparences et les compagnons restent dans ta garde-robe.':
    'Looks and companions stay in your wardrobe.',
  'Le coffre est plein.': 'The chest is full.',
  'Glisse un objet d’une grille à l’autre ou double-clique dessus.':
    'Drag an item from one grid to the other, or double-click it.',
  'Touche un objet pour le déposer ou le retirer.': 'Tap an item to deposit or withdraw it.',
  // ui/stash-grid.ts
  'Lié : n’entre pas au coffre': 'Bound: can’t go in the chest',
  'Lié à ce personnage : le coffre ne prend pas les objets liés, même ceux reçus par ton compte.':
    'Bound to this character: the chest takes no bound items, not even those your account received.',
  'Reste dans la garde-robe.': 'Stays in the wardrobe.',
  Déposer: 'Deposit',
  'stash|Retirer': 'Withdraw',
  '{verb} {count}': '{verb} {count}',
  '{verb} tout': '{verb} all',
};
